if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        
        this.productInfoWrapper = this.closest('.product__info-wrapper');
        this.lastScrollY = window.scrollY;
        this.topOffset = 0; // Replace complex scroll tracking with simple offset
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.initializeStickyBehavior();
        
        try {
          if (this.input) {
            this.quantityForm = this.querySelector('.product-form__quantity');
            if (this.quantityForm) {
              this.setQuantityBoundries();
              if (!this.dataset.originalSection && typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
              }
              if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                  const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
                  if (event.data.sectionId !== sectionId) return;
                  this.updateQuantityRules(event.data.sectionId, event.data.html);
                  this.setQuantityBoundries();
                });
              }
            }
          }
        } catch (error) {
          console.error('Error in ProductInfo original functionality:', error);
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.handleScroll) {
          window.removeEventListener('scroll', this.handleScroll);
        }
      }

      initializeStickyBehavior() {
        this.checkAndInitializeSticky();
        setTimeout(() => this.checkAndInitializeSticky(), 100);
      }

      checkAndInitializeSticky() {

        const hascompleteLookSection = document.querySelector(".complete-look-section");
        //const hasColumnSticky = this.classList.contains('product__column-sticky');
        const isDesktop = window.innerWidth >= 750;
        
        if (hascompleteLookSection && isDesktop && !this.stickyInitialized) {
          this.cacheStickyBaseTop();
          this.handleScroll = this.handleScroll.bind(this);
          window.addEventListener('scroll', this.handleScroll, { passive: true });
          this.stickyInitialized = true;
          requestAnimationFrame(() => this.handleScroll());
        }
      }

      cacheStickyBaseTop() {
        if (this.stickyBaseTop != null) return;
        this.style.removeProperty('top');
        const computedTop = parseFloat(getComputedStyle(this).top);
        this.stickyBaseTop = Number.isFinite(computedTop) ? computedTop : 130;
      }

      resetStickyTop() {
        this.topOffset = 0;
        this.style.removeProperty('top');
        this.style.removeProperty('transition');
      }

      handleScroll() {

        if (!this.classList.contains('product__column-sticky') || 
            window.innerWidth < 750 || !this.productInfoWrapper) {
          return;
        }

        this.cacheStickyBaseTop();
       
        const completeLookGrid = document.querySelector('.complete-look-grid-container');
        if (!completeLookGrid) {
          this.resetStickyTop();
          this.lastScrollY = window.scrollY;
          return;
        }

        const currentScrollY = window.scrollY;

        if (currentScrollY <= 20) {
          this.resetStickyTop();
          this.lastScrollY = currentScrollY;
          return;
        }

        const elementRect = this.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const elementHeight = this.offsetHeight;
        
        const utilityBar = document.querySelector('.utility-bar');
        const utilityBarHeight = utilityBar ? utilityBar.offsetHeight : 0;

        const scrollingDown = currentScrollY > this.lastScrollY + 1;
        const scrollingUp = currentScrollY < this.lastScrollY - 1;
        const scrollDifference = Math.abs(currentScrollY - this.lastScrollY);
        const viewportBottom = windowHeight - 32;

        const ctlRect = completeLookGrid.getBoundingClientRect();
        const ctlOverflow = ctlRect.bottom - viewportBottom;

        const maxNegativeOffset = Math.min(
          -utilityBarHeight,
          viewportBottom - elementHeight - this.stickyBaseTop,
          this.topOffset - Math.max(0, ctlOverflow)
        );

        if (scrollingDown && ctlOverflow > 0) {
          const shift = Math.min(ctlOverflow, scrollDifference);
          this.topOffset = Math.max(this.topOffset - shift, maxNegativeOffset);
        } else if (scrollingDown && elementRect.bottom > viewportBottom) {
          this.topOffset = Math.max(this.topOffset - scrollDifference, maxNegativeOffset);
        } else if (scrollingUp && this.topOffset < 0) {
          const newTopOffset = this.topOffset + scrollDifference;
          this.topOffset = Math.min(newTopOffset, 0);
        }

        if (this.topOffset === 0) {
          this.resetStickyTop();
        } else {
          this.style.setProperty('top', `${this.stickyBaseTop + this.topOffset}px`, 'important');
        }

        this.lastScrollY = currentScrollY;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}